import React from 'react';
import {domMax, LazyMotion} from 'framer-motion';
import {GatsbyBrowser} from 'gatsby';

const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({element}) => {
  return <LazyMotion features={domMax}>{element}</LazyMotion>;
};

export default wrapRootElement;
